import { gql } from '@apollo/client';

export const BRAND_REPORT_FRAGMENT = gql`
  fragment BrandReport on ReportInterface {
    id
    pressroom {
      id
    }
    title
    description
    campaign
    companyName
    brandColor
    visibleMetrics
    version
    locale
    prValueSetting @include(if: $includePrValueSetting) {
      ...Report2PrValueSetting
    }
    coverImage {
      id
      url(transformation: LIMIT_1000)
    }
    logotype {
      id
      url(transformation: LIMIT_1000)
    }
    ... on BrandReport {
      totalHits
      fromDate
      toDate
      state2
      ...BrandReportStaticData
    }
    sections2 {
      id
      ...Report2Section
      ... on ReportMenuSection {
        id
        ...Report2MenuSection
      }
      ... on ReportSummarySection {
        id
        ...Report2SummarySection
      }
      ... on ReportVisibilitySection {
        id
        ...Report2VisibilitySection
      }
      ... on ReportVisibilityBenchmarkSection {
        id
        ...Report2VisibilityBenchmarkSection
      }
      ... on ReportPerceptionSection {
        id
        ...Report2PerceptionSection
      }
      ... on ReportPerceptionBenchmarkSection {
        id
        ...Report2PerceptionBenchmarkSection
      }
    }
  }
`;

export const REPORT2_PR_VALUE_SETTING_FRAGMENT = gql`
  fragment Report2PrValueSetting on ReportPrValueSetting {
    currency
    cpc
    cpm
    twitterCpm
    facebookCpm
    instagramCpm
    differentFromDefault
    pricingModel
  }
`;

export const REPORT2_SECTION_FRAGMENT = gql`
  fragment Report2Section on ReportAllSectionsInterface {
    id
    title
    description
    state
  }
`;

export const BRAND_REPORT_STATIC_DATA_FRAGMENT = gql`
  fragment BrandReportStaticData on BrandReport {
    id
    pressroom {
      id
    }
    brand
    compareToPreviousYear
    mediaTypes
    fromDate
    toDate
    timespan
    searchProfiles {
      id
      name
    }
    competitorSearchProfiles: competitorSearchProfiles2 {
      ids
      name
    }
    excludedSourceGroups {
      id
      name
    }
  }
`;
